import React, { useState } from "react";
import { signOutFunction } from "Pages/Settings/Functions/SignoutFunction";
import SeoFunction from "Pages/Settings/Functions/SeoFunction";
import { CustomTheme } from "./CustomTheme";

export const ActionBarSetting = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isCustomThemeOpen, setIsCustomThemeOpen] = useState(false);

  const sections = [
    {
      title: "Privacy Policy",
      action: () => {
        window.location.href = "privacy-policy.html";
      },
    },
    {
      title: "Submit a Feature Request",
      action: () => {
        window.open("https://tally.so/r/nPla6b");
      },
    },
    {
      title: "SEO Setting",
      action: () => setIsOpen(true),
    },
    {
      title: "Custom Theme",
      action: () => setIsCustomThemeOpen(!isCustomThemeOpen),
    },
    {
      title: "Sign Out",
      action: signOutFunction,
    },
  ];
  return (
    <div className="flex flex-col items-start">
      {sections.map((item, index) => {
        return (
          <span
            className="cursor-pointer text-primary  hover:bg-primary-varients-100 transition duration-300 font-semibold px-3 py-1 rounded-md w-full"
            onClick={item?.action}
            key={index}
          >
            {item?.title}
          </span>
        );
      })}
      <SeoFunction isOpen={isOpen} onClose={() => setIsOpen(false)} />
      <CustomTheme
        isCustomThemeOpen={isCustomThemeOpen}
        setIsCustomThemeOpen={setIsCustomThemeOpen}
      />
    </div>
  );
};
